import React, { useCallback } from 'react'
import { Body1, Body2, Button, Dialog, DialogTitle, Stack } from '@collaborate-health/uikit'
import { DialogActions, DialogContent } from '@mui/material'
import moment from 'moment'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ContentCheckInsQueryKeys } from '@tabeeb/modules/checkIns/requests'
import { useDispatch } from '@tabeeb/store'
import { onAddErrorNotification, onAddSuccessNotification } from '@tabeeb/modules/notification/actions'
import { useApi } from '@tabeeb/shared/utils/API'
import { RemoveUserRecordsDialogProps } from './RemoveUserRecordsDialog.types'

const RemoveUserRecordsDialog: React.FC<RemoveUserRecordsDialogProps> = ({ open, onClose, user, contentId }) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  const { mainApi } = useApi()

  const removeRecordsMutation = useMutation({
    mutationFn: () => mainApi.tracking.deleteUserRecordsAsync(contentId, user.Id, { date: user.CreatedOn }),
    onSuccess: async () => {
      dispatch(onAddSuccessNotification({ message: 'Records removed successfully' }))
      await queryClient.invalidateQueries({ queryKey: [ContentCheckInsQueryKeys.TrackingSnapshot, contentId] })
      onClose()
    },
    onError: () => {
      dispatch(onAddErrorNotification({ message: 'Failed to remove records' }))
    },
  })

  const onSubmit = useCallback(() => {
    removeRecordsMutation.mutate()
  }, [removeRecordsMutation])

  return (
    <Dialog open={open} fullWidth onClose={onClose}>
      <DialogTitle>
        Remove records for {user.UserName && user.UserName.length > 1 ? user.UserName : user.UserEmail}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={1}>
          <Body1>Are you sure you want to remove records of this user for the following date?</Body1>
          <Body2 mt={2}>Date: {moment(user.CreatedOn).format('MM/DD/yyyy')}</Body2>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color='primary' variant='text' onClick={onClose}>
          Cancel
        </Button>
        <Button
          color='primary'
          variant='contained'
          onClick={onSubmit}
          disabled={removeRecordsMutation.isPending}
          loading={removeRecordsMutation.isPending}
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveUserRecordsDialog

